"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _react = require("react");
var _functions = require("../utils/functions");
var _constants = require("../utils/constants");
var _Localization = require("../Localization");
var _useReactHooks = require("./useReactHooks");
const _useFilterList = props => {
  const {
    activeFilters = {},
    data = [],
    filterTypes = [],
    objectId = 'id',
    config = []
  } = props;
  const [filteredData, setFilteredData] = (0, _react.useState)([]);
  const [filteredIdList, setFilteredIdList] = (0, _react.useState)([]);
  const tV = (0, _Localization.useTranslationValue)();
  const setFilteredDataFunc = (0, _useReactHooks.useDeepCallback)(() => {
    return data ? data.filter(item => {
      return Object.keys(activeFilters).reduce((accKey, key) => {
        if (key === _constants.filterTypes.search) {
          if (activeFilters[key] === '') {
            return item;
          } else {
            var _option, _activeFilters$key;
            const {
              option
            } = config.find(c => c.type === _constants.filterTypes.search) || {};
            return option === null || option === void 0 || (_option = option(item, tV)) === null || _option === void 0 ? void 0 : _option.toLowerCase().includes((_activeFilters$key = activeFilters[key]) === null || _activeFilters$key === void 0 ? void 0 : _activeFilters$key.toLowerCase());
          }
        }
        return accKey && ((0, _functions.isArray)(activeFilters[key]) ? activeFilters[key].length ? activeFilters[key].reduce((acc, v) => acc || ((0, _functions.isArray)(v) ? !!v.find(_v => _v === tV(item[key])) : tV(item[key]) === v), false) : true : activeFilters[key] && tV(item[key]) === activeFilters[key]);
      }, true);
      // return !((display_warnings && isNaN(card.devices?.find(s => !s.status)))
      //     || (city && card.city !== city)
      //     || (zip && card.zip !== zip));
    }) : [];
  }, [data, activeFilters, filterTypes, objectId, tV, config]);
  (0, _useReactHooks.useDeepEffect)(() => {
    setFilteredData(setFilteredDataFunc());
  }, [setFilteredDataFunc, data, activeFilters, filterTypes]);
  (0, _react.useEffect)(() => {
    setFilteredIdList(filteredData.map(d => d[objectId]));
  }, [filteredData, objectId]);
  return {
    filteredData,
    filteredIdList
  };
};
var _default = exports.default = _useFilterList;